module.exports = __webpack_public_path__ + "img/logo_univision.3c0aab32.svg";